import { createColumnHelper } from "@tanstack/react-table";
import Table from "components/ui/Table";
import { TableBreakpoint } from "components/ui/Table/interface";
import { palette } from "lib/miolo";
import numeral from "numeral";
import ClipLoader from "react-spinners/ClipLoader";
import type { IDividendsPaidByYearDetails } from "types/graphqlTypes";

interface IDividendsPaidTabContentProps {
  dividendsPaidByYear: IDividendsPaidByYearDetails[];
  loading: boolean;
}

export default function YearlyDividendsPaidTabContent({ dividendsPaidByYear, loading }: IDividendsPaidTabContentProps) {
  const columnHelper = createColumnHelper<IDividendsPaidByYearDetails>();

  const arrayOfColumns = [
    columnHelper.accessor("fiscalYear", {
      header: "Ano",
    }),
    columnHelper.accessor("tickerSymbol", {
      header: "Ação",
      meta: {
        breakpoint: TableBreakpoint.Small,
      },
    }),
    columnHelper.accessor("amountPaid", {
      header: "Valor (R$)",
      cell: (props) => numeral(props.getValue()).format("0.00").replace(".", ","),
      meta: {
        breakpoint: TableBreakpoint.Small,
      },
    }),
  ];

  return (
    <div className="flex flex-col items-end space-y-2">
      {loading && (
        <div className="flex w-full items-center justify-center">
          <ClipLoader size={28} color={palette.royalBlue} loading={true} />
        </div>
      )}

      {!loading && (
        <Table<IDividendsPaidByYearDetails>
          columns={arrayOfColumns}
          data={dividendsPaidByYear ?? []}
          isOddEven={true}
          isPaginationEnabled={true}
        />
      )}
    </div>
  );
}
